import * as React from "react";
const BuildSVG = () => (
    <svg
        viewBox="-0.5 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full"
    >
        <g id="Plan" transform="translate(-401.03 -70.142)">
            <g id="Group_8" data-name="Group 8">
                <g id="Group_7" data-name="Group 7">
                    <path
                        id="Path_10"
                        data-name="Path 10"
                        d="M480.03,97.331v49.811a3,3,0,0,1-3,3H417.68a16.671,16.671,0,0,1-16.65-16.65V89.752c0-9.49,7.741-16.65,18-16.65a3,3,0,0,1,3,3V94.331h23.991V73.142a3,3,0,0,1,3-3H464.33a3,3,0,0,1,3,3V94.331h9.7A3,3,0,0,1,480.03,97.331Zm-6,46.811V100.331h-6.7v26.6a2.977,2.977,0,0,1-.6,1.8l-7.671,10.231a3,3,0,0,1-4.8,0l-7.64-10.2a3,3,0,0,1-.6-1.8V100.331H422.03v19.5a3,3,0,0,1-3,3c-6.95,0-12,4.48-12,10.661a10.666,10.666,0,0,0,10.65,10.65Zm-12.7-23.571V89.462h-9.309v31.13Zm0-37.1v-7.33h-9.309v7.33Zm-4.67,48.69,4.2-5.591-8.379.021Zm-40.63-15.121V79.392c-5.36,1.1-9,5.12-9,10.36v31.12A18.429,18.429,0,0,1,416.03,117.041Z"
                        fill="#104386"
                    />
                    <path
                        id="Path_11"
                        data-name="Path 11"
                        d="M474.03,100.331v43.811H417.68a10.666,10.666,0,0,1-10.65-10.65c0-6.181,5.05-10.661,12-10.661a3,3,0,0,0,3-3v-19.5h23.991v26.631a3,3,0,0,0,.6,1.8l7.64,10.2a3,3,0,0,0,4.8,0l7.671-10.231a2.977,2.977,0,0,0,.6-1.8v-26.6Z"
                        fill="#f60"
                    />
                    <path
                        id="Path_12"
                        data-name="Path 12"
                        d="M461.33,89.462v31.109l-9.31.021V89.462Z"
                        fill="#ffffff"
                    />
                    <rect
                        id="Rectangle_6"
                        data-name="Rectangle 6"
                        width={9.31}
                        height={7.33}
                        transform="translate(452.021 76.142)"
                        fill="#69f"
                    />
                    <path
                        id="Path_13"
                        data-name="Path 13"
                        d="M416.03,79.392v37.649a18.429,18.429,0,0,0-9,3.831V89.752C407.03,84.512,410.67,80.492,416.03,79.392Z"
                        fill="#69f"
                    />
                </g>
            </g>
        </g>
    </svg>
);
export default BuildSVG;